import React from 'react';
import {connect} from "react-redux";
import Field from "./Field";
import {Divider} from "material-ui";
import {CSVLink} from 'react-csv';
import Button from 'material-ui/Button';
import {getTimeObjectJsx, getTimeString} from "../service/getDuration";
import AppTheme from '../components/AppTheme';
import {setClearResults} from '../actions/filters';
import ClearButton from "./common/ClearButton";
import FilterInfoPanel from "./FilterInfoPanel";

const csvHeaders = [
    {label: 'Ключ продукта', key: 'username'},
    {label: 'Входов в игру', key: 'sessions'},
    {label: 'Время в игре', key: 'playTime'},
    {label: 'Среднее время в игре', key: 'sessionsLength'},
]

const Usage=({usage, filters, dispatch})=>{
    if(usage===undefined || !Array.isArray(usage) || usage.length === 0){
        return null;
    }
    return  <AppTheme>
        <div className='usage-container'>
        <ClearButton panel='usage'/>
        <FilterInfoPanel />
        {   usage
            .map((item,index)=>(
                <div key={index}>
                    <div className='metrika-container' >
                        <Field object={item} field='username'/>
                        <Field object={item} field='sessions'/>
                        <Field object={
                            {
                                playTime : getTimeObjectJsx(item.playTime)
                            }
                        } field='playTime'/>
                        <Field object={
                            {
                                sessionsLength : getTimeObjectJsx(item.sessionsLength)
                            }
                        } field='sessionsLength'/>
                    </div>
                    <Divider/>
                </div>))}
        <CSVLink
            data={usage.map(item=>(
                {
                    username : item.username,
                    sessions : item.sessions,
                    playTime : getTimeString(item.playTime),
                    sessionsLength : getTimeString(item.sessionsLength),
                }
            ))}
            filename='SchoolUsage.csv'
            className ='inline common-margin'
            headers={csvHeaders}>
            <Button variant="raised" color="primary"  className='common-btn'>
                Скачать
            </Button>
        </CSVLink>
        </div></AppTheme>
};

const mapStateToProps=(state)=>({usage:state.data.usage, filters: state.filters});
const ConnectedUsage=connect(mapStateToProps)(Usage);
export default ConnectedUsage;